import type {
  BlockStateDefinition,
  ComponentType,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockStateUnionType, BlockType } from '@unifyapps/defs/types/block';
import { ComposedBlockComponentType } from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importRepeatableListComponent = () =>
  import(
    /* webpackChunkName: "repeatable-list-block" */
    '../Repeatable/Repeatable'
  ) as Promise<{ default: ComponentType }>;

const RepeatableList = lazy(importRepeatableListComponent) as ComponentType;

class RepeatableListBlockStateDefinition implements BlockStateDefinition {
  get type() {
    return ComposedBlockComponentType.RepeatableList;
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['componentType', 'content', 'appearance']),
        ..._pick(block, ['events']),
      }) as BlockStateUnionType;
  }

  getComponent() {
    return RepeatableList;
  }

  preload() {
    return {
      blockPreload: importRepeatableListComponent,
    };
  }
}

export default RepeatableListBlockStateDefinition;
